// Get the host name
const hostname = window && window.location && window.location.hostname;

/**
 * Determine whether this is a production domain
 * @returns true if this is a production domain, false otherwise
 */
function isProductionDomain() {
  return (hostname === "developer.cna.com" || hostname === "tech-dev-portal-app.gcp.cna.com");
}

export {
  isProductionDomain
};

/**
 * Determine whether this is a Staging domain
 * @returns true if this is a Staging domain, false otherwise
 */
function isStagingDomain() {
  return (hostname === "stg-developer.cna.com" || hostname === "tech-dev-portal-app-stg.gcp.cna.com");
}

export {
  isStagingDomain
};
